(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function initHeaderMegaMenus() {
    if (window.matchMedia('(max-width: 989px)').matches) return;
    document.querySelectorAll('.mega-menu').forEach((details) => {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.mega-menu__content');
      const tabs = details.querySelectorAll('.mega-menu__submenu-link');
      const panels = details.querySelectorAll('[data-mega-panel]');
      const originalParent = content ? content.parentNode : null;
      const nextSibling = content ? content.nextSibling : null;
      let closeTimer = null;
      let activeHeader = null;
      const getHeader = () => document.querySelector('.section-header .header-wrapper') || document.querySelector('.section-header');
      const positionContent = () => {
        if (!content) return;
        const header = getHeader();
        if (!header) return;
        const headerBottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
        content.style.setProperty('--mega-menu-top', `${headerBottom}px`);

        const banner = document.querySelector('[id^="VideoBanner-"]');
        const bannerBottom = banner ? Math.round(banner.getBoundingClientRect().bottom) : 0;
        const availableHeight = bannerBottom > headerBottom
          ? bannerBottom - headerBottom
          : window.innerHeight - headerBottom;
        content.style.setProperty('--mega-menu-height', `${Math.max(0, availableHeight)}px`);
      };
      const activate = (targetId) => {
        tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.megaTarget === targetId));
        panels.forEach((panel) => panel.classList.toggle('is-active', panel.id === targetId));
      };
      const mountContent = () => {
        if (!content || !originalParent) return;
        positionContent();
        if (content.parentNode !== document.body) document.body.appendChild(content);
        content.classList.add('is-open');
      };
      const restoreContent = () => {
        if (!content || !originalParent) return;
        if (content.parentNode === document.body) {
          if (nextSibling && nextSibling.parentNode === originalParent) {
            originalParent.insertBefore(content, nextSibling);
          } else {
            originalParent.appendChild(content);
          }
        }
        content.classList.remove('is-open');
      };
      const openMenu = () => {
        window.clearTimeout(closeTimer);
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
        activeHeader = getHeader();
        if (activeHeader) activeHeader.classList.add('header-wrapper--mega-menu-open');
        mountContent();
        if (tabs[0]) activate(tabs[0].dataset.megaTarget);
      };
      const closeMenu = () => {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
        if (activeHeader) activeHeader.classList.remove('header-wrapper--mega-menu-open');
        activeHeader = null;
        restoreContent();
      };
      const scheduleClose = () => {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(closeMenu, 160);
      };
      window.addEventListener('resize', positionContent);
      summary.addEventListener('mouseenter', openMenu);
      summary.addEventListener('focus', openMenu);
      details.addEventListener('mouseleave', scheduleClose);
      if (content) {
        content.addEventListener('mouseenter', openMenu);
        content.addEventListener('mouseleave', scheduleClose);
      }
      tabs.forEach((tab) => {
        tab.addEventListener('mouseenter', () => activate(tab.dataset.megaTarget));
        tab.addEventListener('focus', () => activate(tab.dataset.megaTarget));
        tab.addEventListener('click', (event) => { event.preventDefault(); activate(tab.dataset.megaTarget); });
      });
    });
  }

  function initHeaderDropdownMenus() {
    if (window.matchMedia('(max-width: 989px)').matches) return;
    document.querySelectorAll('.header-menu-dropdown').forEach((details) => {
      const summary = details.querySelector('summary');
      let closeTimer = null;
      const openMenu = () => {
        window.clearTimeout(closeTimer);
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      };
      const closeMenu = () => {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      };
      const scheduleClose = () => {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(closeMenu, 120);
      };
      summary.addEventListener('mouseenter', openMenu);
      summary.addEventListener('focus', openMenu);
      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', scheduleClose);
    });
  }

  function initHomepageOverlayHeader() {
    document.querySelectorAll('.header-wrapper--homepage-overlay').forEach((header) => {
      if (header.dataset.homepageOverlayBound === 'true') return;
      header.dataset.homepageOverlayBound = 'true';

      const updateHeaderState = () => {
        header.classList.toggle('header-wrapper--homepage-scrolled', window.scrollY > Math.max(24, header.offsetHeight / 2));
      };

      updateHeaderState();
      window.addEventListener('scroll', updateHeaderState, { passive: true });
    });
  }

  function initMobileShopMenus() {
    document.querySelectorAll('[data-mobile-shop-menu]').forEach((menu) => {
      if (menu.dataset.mobileShopBound === 'true') return;
      menu.dataset.mobileShopBound = 'true';

      const tabs = menu.querySelectorAll('[data-mobile-shop-target]');
      const panels = menu.querySelectorAll('[data-mobile-shop-panel]');
      const activate = (targetId) => {
        tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.mobileShopTarget === targetId));
        panels.forEach((panel) => panel.classList.toggle('is-active', panel.id === targetId));
        menu.closest('.menu-drawer__inner-submenu')?.scrollTo({ top: 0, behavior: 'smooth' });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activate(tab.dataset.mobileShopTarget));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initHeaderMegaMenus();
      initHeaderDropdownMenus();
      initHomepageOverlayHeader();
      initMobileShopMenus();
    });
  } else {
    initHeaderMegaMenus();
    initHeaderDropdownMenus();
    initHomepageOverlayHeader();
    initMobileShopMenus();
  }

  } catch(e) { console.error(e); }
})();
})();
